"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSubHeader = exports.StyledRepresentativeText = exports.StyledRepresentativeCTAWrapper = exports.StyledParagraphText = exports.StyledMarketingCard = exports.StyledLink = exports.StyledLineBreak = exports.StyledHeader = exports.StyledContent = exports.StyledCardIcon = exports.StyledButtonSlot = void 0;
var _server = require("react-dom/server");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _links = require("../../fuse-link/src/links");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledMarketingCard = exports.StyledMarketingCard = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'borderColour';
  }
}).attrs({
  className: 'fuse-marketing-card'
}).withConfig({
  displayName: "styled-marketing-card__StyledMarketingCard",
  componentId: "sc-wekxu8-0"
})(["", " border-radius:var(--border-radius-l);padding:var(--spacing-global-space5);display:flex;"], function (_ref) {
  var borderColour = _ref.borderColour;
  return borderColour === 'brandMid' ? "border: var(--border-width-xs) solid var(--color-brand-mid);" : "box-shadow: var(--elevation-shadow-xs);";
});
var StyledContent = exports.StyledContent = _styledComponents["default"].span.attrs({
  className: 'fuse-marketing-card__content',
  'data-testid': 'fuse-marketing-card__content'
}).withConfig({
  displayName: "styled-marketing-card__StyledContent",
  componentId: "sc-wekxu8-1"
})(["display:flex;width:100%;flex-direction:column;*:last-child{margin:0;}"]);
var StyledHeader = exports.StyledHeader = _styledComponents["default"].span.attrs({
  className: 'fuse-marketing-card__header',
  'data-testid': 'fuse-marketing-card__header'
}).withConfig({
  displayName: "styled-marketing-card__StyledHeader",
  componentId: "sc-wekxu8-2"
})(["position:relative;display:grid;grid-template-columns:1fr ", ";align-items:flex-start;grid-column-gap:12px;margin-bottom:var(--spacing-global-space4,12px);"], function (_ref2) {
  var hasIcon = _ref2.hasIcon;
  return hasIcon && "32px";
});
var StyledCardIcon = exports.StyledCardIcon = _styledComponents["default"].span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'icon';
  }
}).attrs({
  className: 'fuse-marketing-card__icon',
  'data-testid': 'fuse-marketing-card__icon'
}).withConfig({
  displayName: "styled-marketing-card__StyledCardIcon",
  componentId: "sc-wekxu8-3"
})(["position:absolute;top:0;right:0;display:grid;height:var(--spacing-global-space7);width:var(--spacing-global-space7);background:var(--color-brand-mid);", ";"], function (_ref3) {
  var icon = _ref3.icon;
  var RenderIcon = function RenderIcon(Icon) {
    return (0, _server.renderToStaticMarkup)(Icon);
  };
  return "\n\t\tmask: url(\"data:image/svg+xml,".concat(icon && encodeURIComponent(RenderIcon(icon)), "\") center/contain no-repeat;\n\t\t-webkit-mask: url(\"data:image/svg+xml,").concat(icon && encodeURIComponent(RenderIcon(icon)), "\") center/contain no-repeat;\n\t");
});
var StyledSubHeader = exports.StyledSubHeader = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-marketing-card__sub-header',
  'data-testid': 'fuse-marketing-card__sub-header'
}).withConfig({
  displayName: "styled-marketing-card__StyledSubHeader",
  componentId: "sc-wekxu8-4"
})(["margin-bottom:var(--spacing-global-space2,4px);"]);
var StyledParagraphText = exports.StyledParagraphText = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-marketing-card__paragraph-text',
  'data-testid': 'fuse-marketing-card__paragraph-text'
}).withConfig({
  displayName: "styled-marketing-card__StyledParagraphText",
  componentId: "sc-wekxu8-5"
})([""]);
var StyledRepresentativeCTAWrapper = exports.StyledRepresentativeCTAWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-marketing-card__representative-text-cta-wrapper',
  'data-testid': 'fuse-marketing-card__representative-text-cta-wrapper'
}).withConfig({
  displayName: "styled-marketing-card__StyledRepresentativeCTAWrapper",
  componentId: "sc-wekxu8-6"
})(["display:flex;flex-wrap:wrap;gap:var(--spacing-global-space5);@media screen and (min-width:", "){align-items:center;}"], _grid.gridConfig.m.minWidth);
var StyledRepresentativeText = exports.StyledRepresentativeText = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-marketing-card__representative-text',
  'data-testid': 'fuse-marketing-card__representative-text'
}).withConfig({
  displayName: "styled-marketing-card__StyledRepresentativeText",
  componentId: "sc-wekxu8-7"
})(["@media screen and (min-width:", "){flex:1 1 auto;}"], _grid.gridConfig.m.minWidth);
var StyledButtonSlot = exports.StyledButtonSlot = _styledComponents["default"].div.attrs({
  className: 'fuse-marketing-card__button-wrapper',
  'data-testid': 'fuse-marketing-card__button-wrapper'
}).withConfig({
  displayName: "styled-marketing-card__StyledButtonSlot",
  componentId: "sc-wekxu8-8"
})(["width:100%;@media screen and (min-width:", "){width:fit-content;}"], _grid.gridConfig.m.minWidth);
var StyledLineBreak = exports.StyledLineBreak = _styledComponents["default"].span.attrs({
  className: 'fuse-marketing-card__line-break',
  'data-testid': 'fuse-marketing-card__line-break'
}).withConfig({
  displayName: "styled-marketing-card__StyledLineBreak",
  componentId: "sc-wekxu8-9"
})(["margin:var(--spacing-global-space2) 0 var(--spacing-global-space5);height:1px;background:var(--color-functional-divider);"]);
var StyledLink = exports.StyledLink = (0, _styledComponents["default"])(_links.Link).attrs({
  className: 'fuse-marketing-card__link',
  'data-testid': 'fuse-marketing-card__link'
}).withConfig({
  displayName: "styled-marketing-card__StyledLink",
  componentId: "sc-wekxu8-10"
})(["width:fit-content;"]);